'use strict';

var React = require('react');

var SvgFlowerIcon = function SvgFlowerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.749 11.957c2.545-.294 4.501-2.066 4.501-4.207 0-2.347-2.35-4.25-5.25-4.25s-5.25 1.903-5.25 4.25c0 2.141 1.956 3.913 4.501 4.207a.763.763 0 0 0-.001.043v4.25a.75.75 0 0 0 1.5 0v-4.25l-.001-.043Zm-.749-1.457c2.383 0 3.75-1.512 3.75-2.75s-1.367-2.75-3.75-2.75-3.75 1.512-3.75 2.75 1.367 2.75 3.75 2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5 15c0 .446-.083.872-.235 1.265a3.5 3.5 0 0 1-4.53-4.53 3.5 3.5 0 0 1 4.765 3.265Zm-3.5-2a2 2 0 0 1 2 2 2 2 0 0 1-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 15c0 .446.083.872.235 1.265a3.5 3.5 0 0 0 4.53-4.53 3.5 3.5 0 0 0-4.765 3.265Zm3.5-2a2 2 0 0 0-2 2 2 2 0 0 0 2-2Z"
  }));
};
SvgFlowerIcon.displayName = "FlowerIcon";

exports.SvgFlowerIcon = SvgFlowerIcon;
